export { Logo } from "./component";
export type { LogoProps } from "./types";
